import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';

interface NavigationSkeletonProps {
  variant?: 'home' | 'internal' | 'sticky';
  isDarkSection?: boolean;
  isScrolled?: boolean;
  itemCount?: number;
}

const NavigationSkeleton: React.FC<NavigationSkeletonProps> = ({ 
  variant = 'internal',
  isDarkSection = false,
  isScrolled = false,
  itemCount = 6 
}) => {
  const { language } = useLanguage();

  const getSkeletonColor = () => {
    if (variant === 'home' && !isScrolled && isDarkSection) {
      return 'bg-white/20';
    }
    return 'bg-gray-200';
  };

  return (
    <div className="hidden lg:flex items-center space-x-2 rtl:space-x-reverse">
      {Array.from({ length: itemCount }).map((_, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: index * 0.1 }}
          className={`h-8 rounded-lg animate-pulse ${getSkeletonColor()}`}
          style={{
            width: language === 'ar' 
              ? `${Math.random() * 40 + 80}px` // 80-120px for Arabic
              : `${Math.random() * 30 + 60}px`  // 60-90px for English
          }}
        />
      ))}
    </div>
  );
};

export default NavigationSkeleton;